import { render } from "./autocompleteDomainGroups.vue?vue&type=template&id=4e112b71"
import script from "./autocompleteDomainGroups.vue?vue&type=script&lang=js"
export * from "./autocompleteDomainGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__